import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export enum TRIP_REQUIRED_FIELD_OPTION_VALUES {
  ORG_DEFAULT = 'org_default',
  YES = 'yes',
  NO = 'no',
}

export const TRIP_REQUIRED_FIELD_OPTION_LABELS: Record<
  TRIP_REQUIRED_FIELD_OPTION_VALUES,
  string
> = {
  [TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT]: 'Organization Default',
  [TRIP_REQUIRED_FIELD_OPTION_VALUES.YES]: 'Yes',
  [TRIP_REQUIRED_FIELD_OPTION_VALUES.NO]: 'No',
};

export const tripRequiredFieldOptions: SelectOption[] = [
  {
    value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
    label:
      TRIP_REQUIRED_FIELD_OPTION_LABELS[
        TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
      ],
  },
  {
    value: TRIP_REQUIRED_FIELD_OPTION_VALUES.YES,
    label:
      TRIP_REQUIRED_FIELD_OPTION_LABELS[TRIP_REQUIRED_FIELD_OPTION_VALUES.YES],
  },
  {
    value: TRIP_REQUIRED_FIELD_OPTION_VALUES.NO,
    label:
      TRIP_REQUIRED_FIELD_OPTION_LABELS[TRIP_REQUIRED_FIELD_OPTION_VALUES.NO],
  },
];
